import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=4167e94e&scoped=true&"
import script from "./UsersNew.vue?vue&type=script&lang=js&"
export * from "./UsersNew.vue?vue&type=script&lang=js&"
import style0 from "./UsersNew.vue?vue&type=style&index=0&id=4167e94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167e94e",
  null
  
)

export default component.exports